// Laag voor gasten met alleen leesrechten: stil blokkeren (alleen in het logboek, nooit een melding of label op het scherm)
// en het verbergen van de inhoud als het venster niet voorop staat. De logica zit in leesModus.js.
import { useEffect, useState } from "react";
import { activeerLeesBeveiliging, GEBLOKKEERD_EVENT } from "./leesModus";
import { sessieId, logLezer, leegLogboek, startHartslag } from "./lezerAudit";

const STIJL = `
  html.os-lees, html.os-lees body { -webkit-user-select: none; user-select: none; -webkit-touch-callout: none; }
  html.os-lees input, html.os-lees textarea { -webkit-user-select: text; user-select: text; }
  html.os-lees img { -webkit-user-drag: none; pointer-events: auto; }
  @media print { html.os-lees body { display: none !important; } }
`;

export default function LeesModusLaag({ scherm }) {
  const [verborgen, setVerborgen] = useState(false);

  useEffect(() => {
    document.documentElement.classList.add("os-lees");
    const uit = activeerLeesBeveiliging(setVerborgen);
    sessieId(); // start de sessie in het logboek (eerste regel: login)
    const stopHartslag = startHartslag();
    const toon = (e) => {
      const d = e.detail || {};
      // Alleen vastleggen in het logboek: de gast krijgt nooit te zien dat iets geweigerd is.
      logLezer("geblokkeerd", d.reden);
    };
    // Elke aanraking haalt een eventueel blijvend afdekscherm weg, zodat het scherm nooit "vast" lijkt te zitten.
    const wis = () => setVerborgen(false);
    window.addEventListener("touchstart", wis, { passive: true });
    const wegVoor = () => { if (document.visibilityState === "hidden") leegLogboek(); };
    document.addEventListener("visibilitychange", wegVoor);
    window.addEventListener(GEBLOKKEERD_EVENT, toon);
    return () => { uit(); stopHartslag(); document.removeEventListener("visibilitychange", wegVoor); window.removeEventListener("touchstart", wis); window.removeEventListener(GEBLOKKEERD_EVENT, toon); document.documentElement.classList.remove("os-lees"); };
  }, []);

  useEffect(() => { if (scherm) logLezer("scherm", scherm); }, [scherm]);

  return (
    <>
      <style>{STIJL}</style>
      {verborgen && (
        <div onClick={() => setVerborgen(false)} style={{ position: "fixed", inset: 0, zIndex: 10000, background: "#0b0d12", pointerEvents: "none" }} />
      )}
    </>
  );
}
